import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Theme } from '@mui/material/styles'

import {
  setActiveMember,
  setBiography,
  setGeography,
  setMessage,
  setNavPoint,
  setPrefersDarkMode,
  setRedirectPath,
  setSearchInput,
  setTheme,
  setUser,
  setUserPermissions,
} from './settings.actions'

import { Member, Message, User, UserPermissions } from '../../shared/types'
import { getAppTheme } from '../../shared/config/getAppTheme'

export interface SettingsState {
  prefersDarkMode: boolean
  theme: Theme
  message?: Message
  userPermissions: UserPermissions
  user?: User
  activeMember?: Member
  searchInput?: string
  navPoint: string[]
  biography?: string
  geography?: string
  redirectPath?: string
}

const initialDarkMode: boolean = localStorage.getItem('darkMode') === 'true'

const INITIAL_SETTINGS_STATE: SettingsState = {
  prefersDarkMode: initialDarkMode,
  theme: getAppTheme(initialDarkMode),
  navPoint: window.location.href.replace(`${window.location.origin}/`, '').split('/'),
  userPermissions: {
    events: [],
    members: [],
    eventResults: [],
    user: [],
    eventLocations: [],
    eventMember: [],
    relations: [],
    eventPriceCategories: [],
  },
}

export const settingsStateReducer = reducerWithInitialState(INITIAL_SETTINGS_STATE)
  .case(setPrefersDarkMode, (state, prefersDarkMode) => {
    return ({ ...state, prefersDarkMode })
  })
  .case(setTheme, (state, theme) => {
    return ({ ...state, theme })
  })
  .case(setMessage, (state, message) => {
    return ({ ...state, message })
  })
  .case(setSearchInput, (state, searchInput) => {
    return ({ ...state, searchInput })
  })
  .case(setUserPermissions, (state, userPermissions) => {
    return ({ ...state, userPermissions })
  })
  .case(setNavPoint, (state, navPoint) => {
    return ({ ...state, navPoint })
  })
  .case(setBiography, (state, biography) => {
    return ({ ...state, biography })
  })
  .case(setGeography, (state, geography) => {
    return ({ ...state, geography })
  })
  .case(setUser, (state: SettingsState, user: any) => {
    return ({ ...state, user })
  })
  .case(setActiveMember, (state: SettingsState, activeMember: any) => {
    return ({ ...state, activeMember })
  })
  .case(setRedirectPath, (state: SettingsState, redirectPath: any) => {
    return ({ ...state, redirectPath })
  })
